import styled from '@emotion/styled'

export const Hug = styled.div<{ fullWidth?: boolean; maxWidth: string }>`
  max-width: ${({ maxWidth }) => maxWidth};
  ${({ fullWidth }) => fullWidth && 'width: 100%;'};
`
